import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label } from 'reactstrap';
import NumberInput from '../../common/controls/numberInput';
import SegmentedPicker from '../../common/controls/segmentedPicker';
const ContractSpecSurfaceProfile = props => {
  const onChange = props.onChange,
    _props$active = props.active,
    roughnessMin = _props$active.roughnessMin,
    roughnessMax = _props$active.roughnessMax,
    roughnessUnits = _props$active.roughnessUnits;
  const handleChangeRoughnessMin = value => onChange('roughnessMin', value);
  const handleChangeRoughnessMax = value => onChange('roughnessMax', value);
  const handleChangeRoughnessUnits = value => onChange('roughnessUnits', value);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Surface Profile"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(Label, null, "Roughness"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: roughnessMin,
    entity: "ContractSpec",
    field: "roughnessMin",
    onChange: handleChangeRoughnessMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: roughnessMax,
    entity: "ContractSpec",
    field: "roughnessMax",
    onChange: handleChangeRoughnessMax
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 6,
      offset: 6
    }
  }, /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['Mils', 'Microns'],
    values: [0, 1],
    label: "Roughness Units",
    allowNull: false,
    onChange: handleChangeRoughnessUnits,
    value: roughnessUnits
  }))))));
};
ContractSpecSurfaceProfile.propTypes = {
  active: PropTypes.shape({
    roughnessMax: PropTypes.number,
    roughnessMin: PropTypes.number,
    roughnessUnits: PropTypes.number
  }).isRequired,
  onChange: PropTypes.func.isRequired
};
export default ContractSpecSurfaceProfile;